// @module Aik.AikTest.AikTestExtensionModule
define('ArticlePageModule.View'
,	[
		'PageType.Base.View'
	,	'ArticlePageTemplate.tpl'
	,	'Utils'
	,	'Backbone'
	,	'jQuery'
	,	'underscore'
	]
,	function (
		PageTypeBaseView
	,	First_Template_tpl
	,	Utils
	,	Backbone
	,	jQuery
	,	_

	)
{
	'use strict';

	return PageTypeBaseView.PageTypeBaseView.extend({


		template: First_Template_tpl


	, initialize: function (options) {


	}
	});



});
